// design-store-constants.js
export const TEST = 'TEST';
export const FETCH_SURVEY_DEFINITION = 'FETCH_SURVEY_DEFINITION';
export const UPDATE_TRANSLATION_STATUS = 'UPDATE_TRANSLATION_STATUS';
export const TRANSLATION_LIST = 'TRANSLATION_LIST';
export const UPDATE_SURVEY_WITH_TRANSLATIONS = 'UPDATE_SURVEY_WITH_TRANSLATIONS';